'use client';

import { ReactNode } from 'react';

interface ContainerProps {
  children: ReactNode;
  size?: 'sm' | 'md' | 'lg' | 'xl' | 'full';
  padding?: 'none' | 'sm' | 'md' | 'lg';
  className?: string;
}

const Container: React.FC<ContainerProps> = ({
  children,
  size = 'lg',
  padding = 'md',
  className = ''
}) => {
  // Container size classes
  const sizeClasses = {
    sm: 'max-w-2xl',
    md: 'max-w-4xl', 
    lg: 'max-w-6xl',
    xl: 'max-w-7xl',
    full: 'max-w-full'
  };

  // Responsive padding classes
  const paddingClasses = {
    none: '',
    sm: 'px-3 sm:px-4 md:px-6',
    md: 'px-4 sm:px-6 md:px-8 lg:px-12',
    lg: 'px-4 sm:px-6 md:px-8 lg:px-12 xl:px-16 2xl:px-20'
  };

  return (
    <div className={`mx-auto ${sizeClasses[size]} ${paddingClasses[padding]} ${className}`}>
      {children}
    </div>
  );
};

export default Container;